import type React from 'react';
import Icon from '2-core-elements/Icon/Icon';
import Button from '2-core-elements/Buttons/Button';
import Chip from '3-components/Chip/Chip';

interface DownloadCardProps {
    title: string;
    children?: React.ReactNode;
    tags?: string;
    fileType?: string;
    fileSize?: string;
    documentFileViewURL?: string;
    documentFileDownloadURL?: string;
}

const DownloadCard: React.FC<DownloadCardProps> = ({
    title,
    children,
    tags,
    fileType,
    fileSize,
    documentFileViewURL,
    documentFileDownloadURL,
}) => {
    return (
        <div className="search-result-card">
            <div className="search-result-card-inner">
                <div className="search-result-card-inner-text">
                    <h3 className="search-result-card-title">{title}</h3>
                    {(fileType || fileSize) && (
                        <div className="download-file-details">
                            {fileType && (
                                <div>
                                    <Icon icon="text-snippet" />
                                    <span>{fileType}</span>
                                </div>
                            )}
                            {fileSize && (
                                <div>
                                    <Icon icon="folder" />
                                    <span>{fileSize}</span>
                                </div>
                            )}
                        </div>
                    )}
                    {children && <div className="search-result-card-summary">{children}</div>}
                    {tags && (
                        <Chip
                            skin={'neutral'}
                            variant={tags === 'General pages' ? 'subtle' : 'bold'}
                            label={tags}
                        />
                    )}
                </div>
                {(documentFileViewURL || documentFileDownloadURL) && (
                    <div className="search-result-card-call-to-actions">
                        {documentFileViewURL && (
                            <Button
                                href={documentFileViewURL}
                                target="_blank"
                                size="sm"
                                skin="1"
                                suffixIcon="visibility"
                            >View
                            </Button>
                        )}
                        {documentFileDownloadURL && (
                            <Button
                                href={documentFileDownloadURL}
                                size="sm"
                                suffixIcon="download"
                            >Download
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DownloadCard;
